import { cursorPaginationFieldPolicy } from '../../../../utils/policies';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  AdHocAssetsShare: {
    fields: {
      assets: {
        ...cursorPaginationFieldPolicy(),
        keyArgs: ['folderId', 'filter'],
      },
      aggregationInfo: {
        keyArgs: ['folderId'],
      },
      appearance: { merge: true },
    },
  },
  CollectionShare: {
    fields: {
      assets: {
        ...cursorPaginationFieldPolicy(),
        keyArgs: ['folderId', 'filter'],
      },
    },
  },
  Share: {
    fields: {
      collectionAssets: {
        ...cursorPaginationFieldPolicy(['assetType', 'folderId']),
      },
    },
  },
};
